/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, DateField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import metadata from './FrmrFirmComponent.metadata.json5';

function FrmrFirmComponent(props) {

    const {
        data: frmrFirmVM,
        updateWizardData,
        submissionVM,
        frmrFirmPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);


    const addFrmrFirm = useCallback(
        () => {

            frmrFirmVM.value = frmrFirmVM.value || []

            const { _xCenter, _dtoName } = frmrFirmVM;

            const frmrFirmObjVM = viewModelService.create(
                {isValidationReq: true},
                _xCenter,
                _dtoName
            );

            frmrFirmVM.pushElement(
                frmrFirmObjVM
            );
            updateWizardData(submissionVM);
        },
        [frmrFirmVM, viewModelService, updateWizardData, submissionVM]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            frmrFirmVM.value.splice(index, 1);
            _.set(submissionVM.value, frmrFirmPath, frmrFirmVM.value);
            updateWizardData(submissionVM);
        }, [frmrFirmVM.value, submissionVM, frmrFirmPath, updateWizardData]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            item.isValidationReq = true

            const { path } = props;

            if (path === 'name') {
                const value = item.name ? item.name : '';

                return (
                    <InputField
                        id={index + path}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.name = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'dateEstablished') {
                const value = item.dateEstablished ? item.dateEstablished : '';
            
                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType='object'
                        path={path}
                        format="short"
                        layout="full-width"
                        onValueChange={(val, changedPath) => {
                            item.dateEstablished = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }

            if (path === 'dateCeasedtoOperate') {
                const value = item.dateCeasedtoOperate ? item.dateCeasedtoOperate : '';
            
                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType='object'
                        path={path}
                        format="short"
                        layout="full-width"
                        onValueChange={(val, changedPath) => {
                            item.dateCeasedtoOperate = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }

        }, [handleValueChange])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
            >
                <Icon icon="mi-delete"/>
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`FrmrFirmTable`]: {
            data: frmrFirmVM.value,
        }

    }), [frmrFirmVM])

    const resolvers = {
        resolveCallbackMap: {
            addFrmrFirm,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            frmrFirmVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [frmrFirmVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={frmrFirmVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

FrmrFirmComponent.propTypes = wizardProps;
export default withRouter(FrmrFirmComponent);
